import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@tryhackme/thm-ui-components';
import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const StyledShareIcon = styled(FontAwesomeIcon)`
  & {
    color: ${({ theme }) => theme.colors.white};
  }
`;

export const StyledShareText = styled.span`
  color: ${({ theme }) => theme.colors.addButton.color};
`;

export const StyledShareButton = styled(Button)`
  &&: hover ${StyledShareText} {
    color: ${({ theme }) => theme.colors.black};
  }

  &&: hover ${StyledShareIcon} {
    color: ${({ theme }) => theme.colors.black};
  }
`;

export const StyledShareHeading = styled.span`
  font-size: 2.4rem;
`;

export const StyledRoomLinkWrapper = styled.div`
  padding: 1.8rem;
  background-color: ${({ theme }) => theme.colors.background.grey};
  border-radius: ${({ theme }) => theme.radius.small};
`;

export const StyledCopyText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
`;

export const StyledInfoText = styled.p`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  margin-top: 2.4rem;
`;

export const StyledTHMRoomTag = styled.span`
  padding-left: 0.8rem;
  padding-right: 0.8rem;
  background-color: ${({ theme }) => theme.colors.codeTag.background};
  border-radius: 0.3rem;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.codeTag.text};
  border: 0.1rem solid ${({ theme }) => theme.colors.selectionBox.border};
`;

export const StyledModalDescriptionText = styled.span`
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledLink = styled(Link)`
  text-decoration: none;
`;
